import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import ThemeProvider from "./ThemeContext";
import Loader from "./Components/Common/Loader";
import { GoogleOAuthProvider } from "@react-oauth/google";
import i18next from "i18next";

import initI18n from "./Utilities/Translations/i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

const startApp = async () => {
  await initI18n();

  const langCode =
    localStorage.getItem("i18nextLng") || "en";

  await i18next.changeLanguage(langCode);

  root.render(
    <Suspense fallback={<Loader />}>
      <ThemeProvider>
        <GoogleOAuthProvider
          clientId={process.env.REACT_APP_CLIENT_ID}
        >
          <Router>
            <App />
          </Router>
        </GoogleOAuthProvider>
      </ThemeProvider>
    </Suspense>
  );
};

startApp();